// общее отображение loading на приложении
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';

export const START_PROGRESS_BAR = 'START_PROGRESS_BAR';
export const STOP_PROGRESS_BAR = 'STOP_PROGRESS_BAR';
export const ADD_PROGRESS_BAR = 'ADD_PROGRESS_BAR';
export const CLEAR_PROGRESS_BAR = 'CLEAR_PROGRESS_BAR';
